import { Observable } from '@reactivex/rxjs';
import { axisLeft } from 'd3-axis';
import { select } from 'd3-selection';
import mapPropsStream from 'react-recompose/mapPropsStream';
import createEventHandler from 'react-recompose/createEventHandler';

import yAxisStyleNames from './styles.less';

const withD3YAxes = mapPropsStream(props => {
    const { handler: onRef, stream: refs } = createEventHandler();
    const propsObs = Observable.from(props);

    const renderD3AxisRefs = refs
        .filter(Boolean)
        .combineLatest(propsObs).take(1).map(initialRenderD3Axis)
        .combineLatest(propsObs)
        .do(updateD3Axis);

    return propsObs.merge(renderD3AxisRefs.ignoreElements()).map(props => ({ ...props, onRef }));
});

export const YAxis = withD3YAxes(renderYAxis);

function renderYAxis({ scale, chartWidth, width, x, y, onRef, padding, ...props }) {
    return (
        <g {...props} transform={`translate(${width}, ${5 + padding})`}>
            <g key="d3-y-axis" ref={onRef} />
        </g>
    );
}

function updateD3Axis([gx, props]) {
    const { height: heightRaw, scale, chartWidth, padding } = props;

    const height = heightRaw - padding;

    gx.call(customYAxis(scale, height, chartWidth, padding));
}

function initialRenderD3Axis([axisRef, props]) {
    const { height: heightRaw, scale, chartWidth, padding } = props;

    const height = heightRaw - padding;

    // Draw the new axis
    return select(axisRef)
        .append('g')
        .attr('class', yAxisStyleNames['y-axis'])
        .call(customYAxis(scale, height, chartWidth, padding));
}

const updateAttr = (el, attr, val) => {
    if(el.getAttribute(attr) !== val) {
        el.setAttribute(attr, val);
    }
    return el;
}

const customYAxis = (scale, height, chartWidth, padding) => g => {
    const yAxis = axisLeft(scale)
        .tickSizeInner(10)
        .tickSize(-chartWidth)
        .ticks(Math.min(Math.floor(height / 30), scale.domain()[1]), ',d');
    g.call(yAxis);

    // manually update lines to prevent unnecessary DOM updates
    const lines = g.node().getElementsByTagName('line');
    for(let i = 0; i < lines.length; i++) {
        updateAttr(lines[i], 'y1', 5 - padding); //magic constant..
        updateAttr(lines[i], 'y2', 5 - padding); //magic constant..
    }
};